/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ChatMessageType {
    User = 1,
    Assistant = 2,
    ToolRequest = 3,
    ToolResponse = 4,
    AgentRequest = 5,
    AgentResponse = 6,
}
